import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js';
var ScrollMagic = require('ScrollMagic');
import 'jquery.cookie/jquery.cookie';
import lity from 'lity';
var videoPlaying = false;

function scroll_to_facet($target) {
  if ($target.length) {
    let facetsInitialized = false;

    $(document).on('facetwp-loaded', function() {
      if(window.location.href.indexOf('?_') != -1 && !facetsInitialized) {
        $('html,body').animate({scrollTop: $target.closest('.acf-block').offset().top - $('.nav-fixed').outerHeight() - 20},'slow');
      }

      facetsInitialized = true;
    });
  }
}

function sticky_nav() {
  var stickOffset = 0;
  var $announcementBanner = $('.announcement-banner-wrap');

  if ($announcementBanner.length && $announcementBanner.is(':visible')) {
    stickOffset = $announcementBanner.outerHeight();
  }

  if ($(window).scrollTop() > stickOffset) {
    $('.nav-fixed').addClass('fixed stick');
  } else {
    $('.nav-fixed').removeClass('fixed stick');
  }

  if ($(window).outerWidth() < 992) {
    $('header.page-header .nav-fixed.with-announcement').css('top', stickOffset + 'px');
    $('.navbar-collapse').css('top', (stickOffset + $('.nav-fixed').outerHeight()) + 'px');
    $('.navbar-collapse').css('max-height', 'calc(100vh - ' + (stickOffset + $('.nav-fixed').outerHeight()) + 'px)');
  } else {
    $('header.page-header .nav-fixed.with-announcement').css('top', '');
    $('.navbar-collapse').css('top', '');
    $('.navbar-collapse').css('max-height', '');
  }
}

function news_ticker($news_ticker) {
  var $current = $news_ticker.find('.active');
  var $next = $current.next('.item');

  if ($current.is(':last-child')) {
    $next = $news_ticker.find('.item:nth-child(2)');
  }

  setTimeout(function() {
    $next.addClass('active');
    $current.removeClass('active');
    news_ticker($news_ticker);
  }, 3500);
}

function close_nav() {
  if ($('.navbar-collapse').hasClass('show')) {
    $('.navbar-toggler').trigger('click');
  }

  if ($('body').hasClass('search-open')) {
    $('.search-toggler').trigger('click');
  }
}

export default {
  init() {
    // var brand_colors = Array('primary', 'info', 'warning', 'secondary');
    // $('body').addClass('brand-' + brand_colors[Math.floor(Math.random() * brand_colors.length)]) ;

    var $ticker = $('.news-ticker');

    if ($ticker.length) {
      $ticker.each(function() {
        news_ticker($(this));
      });
    }

    $('.close-announcement').on('click', function() {
      // console.log($(this).parent().data('banner-id'));
      $.cookie($(this).parent().data('banner-id'), 'viewed', { expires: 356, path: '/', secure: true });

      $announcement.slideUp(200, function() {
        $('.nav-fixed').removeClass('with-announcement');
      });

      sticky_nav();
    });

    var $announcement = $('.announcement-banner-wrap');

    if ($announcement.length) {
      if ($.cookie($announcement.data('banner-id'))) {
        $announcement.hide();
        $('.nav-fixed').removeClass('with-announcement');
      } else {
        $announcement.slideDown(200);
        $('.nav-fixed').addClass('with-announcement');
      }

      sticky_nav();
    }

    $(document).on('click', '[data-lity-form]', function(e) {
      e.preventDefault();

      lity(
        $(this).attr('href'), {
        template: '<div class="lity lity-form" role="dialog" aria-label="Dialog Window (Press escape to close)" tabindex="-1"><div class="lity-wrap" data-lity-close role="document"><div class="lity-loader" aria-hidden="true">Loading...</div><div class="lity-container"><div class="lity-content"></div><button class="lity-close" type="button" aria-label="Close (Press escape to close)" data-lity-close>&times;</button></div></div></div>',
      });
    });

    $(window).on('load scroll resize', function(){
      sticky_nav();
    });

    sticky_nav();

    $('.random-photo').each(function() {
      var photos = $(this).data('photos');

      if (photos) {
        setTimeout(function() {
          var photo = photos[Math.floor(Math.random() * photos.length)];

          if ($(this).data('lazy-src')) {
            $(this).data('lazy-src', photo);
          } else if ($(this).attr('data-lazy-src')) {
            $(this).attr('data-lazy-src', photo);
          } else {
            $(this).attr('src', photo);
          }
        }, 200);
      } else {
        photos = $(this).data('bg-photos');
        var credits = $(this).data('bg-credits');

        // console.log(photos);

        if (photos.length && photos[0]) {
          var random_photo_num = Math.floor(Math.random() * photos.length);

          $(this).css('background-image', 'url(' + photos[random_photo_num] + ')');
          $(this).find('.block-inner').append('<div class="photo-credit">' + unescape(credits[random_photo_num].replace(/\+/g, ' ')) + '</div>');
        }
      }
    });

    var $photo_credit_blocks = $('.acf-block[data-photo-credit]');

    if ($photo_credit_blocks) {
      $photo_credit_blocks.each(function() {
        $(this).find('.block-inner').append('<div class="photo-credit">' + unescape($(this).data('photo-credit').replace(/\+/g, ' ')) + '</div>');
      });
    }

    $(document).on('click', 'a[href*="#"]', function(e) {
      var dest = $(this).attr('href');

      //Don't do anything if it's just a generic anchor link
      if (dest != '#' && dest.indexOf('#') !== -1 && !$(this).attr('data-toggle')) {
        var hash = dest.split('#')[1];

        if ($('#'+hash).length > 0) {
          $('html,body').animate({scrollTop: $('#'+hash).offset().top - $('.nav-fixed').outerHeight() - 20},'slow');
          e.preventDefault();
        }
      }
    });

    $(window).on('load', function(){
      var hash = location.hash.replace('#','');
      var $target = $(location.hash);

      if (hash != '' && hash.indexOf('-tab') !== -1) {
        if ($target.length && !$target.hasClass('active')) {
          $('#' + $target.attr('aria-labelledby')).trigger('click');
        }

        $('html, body').animate({scrollTop: $target.closest('.acf-block').offset().top - $('.nav-fixed').outerHeight()}, 'slow');
      } else if(hash != '') {
        if ($target.length) {
          $('html, body').animate({scrollTop: $target.offset().top - $('.nav-fixed').outerHeight() - 20},'slow');

          if ($target.parent().hasClass('accordion')) {
            $target.find('[data-toggle="accordion"]').trigger('click');
          }
        }
      }
    });

    //Enable mobile header nav accordion
    $('body').on('click', '.navbar-collapse ul > li.dropdown > a', function(e) {
      //If we're on the mobile checkpoint we'll enable our mobile accordion functionality. window width should be less than or equal to the small breakpoint in Bootstrap vars file.
      if (window.matchMedia('(max-width: 991.9px)').matches && !$(this).parent().hasClass('show')) {
        $('.navbar-collapse ul > li.dropdown.show').removeClass('show').find('.dropdown-menu').slideUp(200);

        $(this).parent().addClass('show');
        $(this).parent().find('.dropdown-menu').slideDown(200);
        e.preventDefault();
      }
    }).on('click', '.navbar-collapse ul > li.dropdown > a .caret', function(e) {
      if (window.matchMedia('(max-width: 991.9px)').matches) {
        $(this).parent().parent().toggleClass('show');
        $(this).parent().parent().find('.dropdown-menu').slideToggle(200);
        e.preventDefault();
        e.stopPropagation();
      }
    }).on('click', '.navbar-collapse .menu-heading.menu-item-has-children > a', function(e) {
      if (window.matchMedia('(max-width: 991.9px)').matches) {
        $(this).parent().siblings().removeClass('show');
        $(this).parent().siblings().find('> ul').slideUp(200);
        $(this).parent().toggleClass('show');
        $(this).next().slideToggle(200);
        e.preventDefault();
      }
    });

    $('body').on('click', '[data-toggle="body-class"]', function(e) {
      $('body').toggleClass($(this).data('class'));
      e.preventDefault();
    });

    $(document).on('click', '[data-toggle="collapse"]', function(e) {
      e.preventDefault();

      if ($(this).hasClass('search-toggler')) {
        $('body').toggleClass('search-open');
        $('.collapse.navbar-collapse.show').removeClass('show').slideUp(100);
      }
      //  else {
      //   $('body').toggleClass('search-open');
      //   $('#searchform').slideToggle(100);
      // }
    });

    //Activate and deactivate the mobile nav hamburger on click.
    $(document).on('click', '.navbar-toggler', function() {
      $(this).toggleClass('active');
      $($(this).data('target')).slideToggle(100).toggleClass('show');

      if ($(this).hasClass('scroll-lock')) {
        $('html').toggleClass('nav-open modal-open');
      }
    });

    $(document).on('keyup', function(e) {
      if (e.key === 'Escape' || e.code === 'Escape') {
        close_nav();
      }
    }).on('scroll', function() {
      close_nav();
    });

    $('.main').on('click', function() {
      close_nav();
    });

    $(document).on('click', '[data-toggle="collapse"]', function(e) {
      e.preventDefault();
      $($(this).attr('data-target')).slideToggle(200);
    });

    $(document).on('click', '[data-toggle="readmore"]', function(e) {
      e.preventDefault();

      var $target = $($(this).attr('data-target'));

      $target.toggleClass('open');
      $(this).toggleClass('close');

      if ($target.hasClass('open')) {
        $(this).html($(this).data('less-label'));
      } else {
        $(this).html($(this).data('more-label'));
      }
    });


    $(document).on('click', '[data-toggle="accordion"]', function(e) {
      e.preventDefault();

      var $target = $($(this).attr('data-target'));
      var $accordion = $(this).parent().parent();

      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $target.slideUp(500).removeClass('active');
      } else {
        $accordion.find('.toggle-btn').removeClass('active');
        $(this).addClass('active');

        $accordion.find('.accordion-content').slideUp(500).removeClass('active');
        $target.slideDown(500).addClass('active');

        setTimeout(function() {
          $('html,body').animate({scrollTop: $target.parent().offset().top - $('.nav-fixed').outerHeight()}, 'slow');
        }, 500);
      }
    });

    $(document).on('click', '[data-toggle="open"]', function(e) {
      e.preventDefault();
      $($(this).data('target')).toggleClass('open');
    });

    $(document).on('click', '[data-toggle="tab"]', function() {
      // e.preventDefault();

      $(this).parent().parent().find('.active').removeClass('active');
      $(this).addClass('active');

      var $targetTab = $($(this).data('target'));

      $targetTab.parent().find('.active').removeClass('active').slideUp(500, function() {
        $targetTab.slideDown(500).addClass('active');
      });
    });

    $(document).on('click', '.subscribe-form .btn', function(e) {
      e.preventDefault();

      $('#subscribe-modal #input_2_5').val($('.subscribe-form .subscribe-email').val());
      $('#subscribe-modal #input_2_3').trigger('focus');
    });

    //Enable mobile footer nav accordion
    $('.footer-nav.nav > li.menu-item-has-children > a').on('click', function(e) {
      //If we're on the mobile checkpoint we'll enable our mobile accordion functionality. window width should be less than or equal to the small breakpoint in Bootstrap vars file.
      if ($(window).width() < '920') {
        if ($(this).parent().hasClass('open')) {
          $(this).parent().removeClass('open');
        } else {
          $('.footer-nav .nav > li.menu-item-has-children').removeClass('open');
          $(this).parent().addClass('open');
        }

        e.preventDefault();
      }
    });

    $(document).on('facetwp-loaded', function() {
      if (FWP.loaded && $('.facetwp-template').is(':visible')) {
        let $scrollTarget = $('.facetwp-template');

        if ($('.facetwp-scroll-target').length) {
          $scrollTarget = $('.facetwp-scroll-target');
        }

        $('html, body').animate({scrollTop: $scrollTarget.offset().top - $('.nav-fixed').outerHeight() - 20}, 'slow');
      }

      if ($('#project_search_wrap').length > 0) {
        console.log(FWP.settings.pager.total_rows);

        if (FWP.settings.pager.total_rows < 6001) {
          $('#export_facet_to_csv').removeClass('disabled');
          $('#export_facet_to_csv').addClass('tooltip-disabled');
        } else {
          $('#export_facet_to_csv').addClass('disabled');
          $('#export_facet_to_csv').removeClass('tooltip-disabled');
        }
      }
    });

    // If the user selects to download a CSV we'll watch for a cookie set on the CSV single-projects-csv.blade.php template to fire signifyig that the file has started to download.
    if ($('#export_facet_to_csv').length > 0) {
      $('#export_facet_to_csv button').on('mousedown', function() {
        let download_id = Date.now().toString();
        let download_cookie_pattern = new RegExp(('csv_export_' + download_id + '=1'), 'i');
        let $download_button = $(this);

        $(this).attr('data-href', $(this).attr('data-href').split('?')[0] + '?id=' + download_id);
        $download_button.addClass('downloading');

        let download_start_timer = setInterval(function() {
          if ( document.cookie.search( download_cookie_pattern ) >= 0 ) {
            clearInterval(download_start_timer);
            $download_button.removeClass('downloading');
            // alert('Downloaded');
          }
        }, 500);
      });
    }

    $(document).on('click', '.accordion .item .btn-accordion', function(e) {
      if (!$(e.delegateTarget).hasClass('show')) {
        $('.accordion .item').removeClass('show').find('.accordion-body').slideUp(200);
        $(e.delegateTarget).addClass('show').find('.accordion-body').slideDown(200);
      }
    });

    var $closingDocButtons = $('.closing-doc-buttons');

    if ($closingDocButtons.length) {
      $(document).on('facetwp-loaded', function() {
        var $facetFields = $closingDocButtons.prev().find('.facetwp-dropdown');
        var facetValues = [];

        $facetFields.each(function() {
          if ($(this).val()) {
            facetValues.push($(this).val());
          }
        });

        if ($('.closing-doc-buttons .doc-btn').length == 1 || facetValues.length == 3) {
          if ($('.closing-doc-buttons .doc-btn').length == 1) {
            $closingDocButtons.find('#zip_docs_form').addClass('d-none');
          } else if (facetValues.length == 3) {
            var docIDs = [];

            $closingDocButtons.find('.doc-btn').addClass('d-none').each(function() {
              docIDs.push($(this).data('doc-id'));
            });

            $closingDocButtons.find('#zip_docs').val(docIDs);
            $closingDocButtons.find('#zip_docs_form').removeClass('d-none');
          }

          $closingDocButtons.removeClass('d-none');
        } else {
          $closingDocButtons.addClass('d-none');
        }
      });
    }

    $('.clear-facets').on('click', function() {
      FWP.reset();
    });

    scroll_to_facet($('#juror_search_wrap'));
    scroll_to_facet($('#project_search_wrap'));

    $('a.document-link').each(function() {
      var regex = /[0-9]{4}(-[0-9]{4})/;

      // console.log($(this).html());
      // console.log($(this).html().match(regex));
      $(this).html('<span>' + $(this).html().replace(regex, '<span class="no-wrap">$&</span>') + '</span>');
    });

    $('.bg-video-trigger').on('click', function() {
      var $block = $(this).closest('.acf-block');
      var $video = $block.find('video');

      $block.addClass('video-playing');
      $video.prop('muted', false);
      $video.prop('controls', true);
      $video[0].pause();
      $video[0].currentTime = 0;
      $video[0].load();
      videoPlaying = true;
    });

    $(document).on('lity:close', function() {
      if (videoPlaying) {
        $('video').each(function() {
          $(this).prop('muted', true);
          $(this).prop('controls', false);
        });
      }
    });

    var scrollController = new ScrollMagic.Controller();

    $(window).on('load', function() {
      $('.document-pdf').attr('target', '_blank');

      $('[data-toggle="open"]').each(function() {
        var $target = $($(this).data('target'));
        $target.find('.cover').css('maxHeight', 0).css('maxHeight', $target.outerHeight());

        $(window).on('resize', function() {
          $target.find('.cover').css('maxHeight', 0).css('maxHeight', $target.outerHeight());
        });
      });
    });

    let $pinnedSubNav = $('#pinnedSubNav');

    if ($pinnedSubNav.length) {
      // console.log($pinnedSubNav[0].querySelector('nav'));
      new ScrollMagic.Scene({
        triggerElement: '#pinnedSubNav',
        offset: '-60px',
        triggerHook: 0,
      })
      // .addIndicators({name: 'Sticky Nav'})
      .setPin($pinnedSubNav[0].querySelector('nav'), {
        pushFollowers: false,
      })
      .addTo(scrollController);

      $('.acf-block').each(function() {
        let $block = $(this);
        let blockID = '#' + $block.attr('id');

        new ScrollMagic.Scene({
          triggerElement: blockID,
          duration: $block.outerHeight(),
          offset: '-134px',
          triggerHook: 0,
        })
        // .addIndicators({name: 'Block Trigger'})
        .on('enter', function () {
          $pinnedSubNav.find('a').attr('aria-selected', false);

          let selectedNav = $pinnedSubNav.find('[href="' + blockID + '"]');

          if (!selectedNav.length) {
            selectedNav = $pinnedSubNav.find('li:first-child a');
          }

          selectedNav.attr('aria-selected', true);
          $pinnedSubNav.find('nav')[0].scrollTo({left: selectedNav[0].offsetLeft - 17, top: 0, behavior: 'smooth'});
        })
        .addTo(scrollController);
      });
    }


  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js